import { render } from "./stubPage.vue?vue&type=template&id=27f496d6&scoped=true"
import script from "./stubPage.vue?vue&type=script&lang=js"
export * from "./stubPage.vue?vue&type=script&lang=js"

import "./stubPage.vue?vue&type=style&index=0&id=27f496d6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f496d6"]])

export default __exports__